module.exports = __webpack_public_path__ + "img/ic_battery.0f1c5c5d.svg";